const getResponsiveStyles = (screenSize, theme, language, isLoading) => {
  const { isMobile, isTablet } = screenSize;
  const isRTL = language === "ar";

  return {
    container: {
      marginTop: "-40px",
      padding: isMobile ? "0 12px" : "0",
      direction: isRTL ? "rtl" : "ltr",
    },

    card: {
      background:
        theme === "light"
          ? "rgba(255, 255, 255, 1)"
          : "rgba(255, 255, 255, 0.01)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      border:
        theme === "light"
          ? "1px solid rgba(0, 0, 0, 0.05)"
          : "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: isMobile ? "12px" : "16px",
      padding: isMobile ? "16px" : isTablet ? "20px" : "24px",
      marginBottom: "24px",
      marginLeft: isRTL ? 0 : isMobile ? 0 : 20,
      marginRight: isRTL ? (isMobile ? 0 : 20) : 0,
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
      transition: "all 0.3s ease",
    },

    header: {
      marginBottom: isMobile ? "20px" : "24px",
    },

    title: {
      fontSize: isMobile ? "20px" : isTablet ? "22px" : "24px",
      fontWeight: "700",
      color: theme === "light" ? "#0f172a" : "#ffffff",
      margin: "0 0 8px 0",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      textAlign: isRTL ? "right" : "left",
      flexDirection: "row",
    },

    subtitle: {
      fontSize: isMobile ? "13px" : "14px",
      color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
      margin: 0,
      textAlign: isRTL ? "right" : "left",
    },

    tabContainer: {
      display: "flex",
      gap: isMobile ? "8px" : "12px",
      marginBottom: isMobile ? "20px" : "24px",
      borderBottom:
        theme === "light"
          ? "2px solid #e2e8f0"
          : "2px solid rgba(255, 255, 255, 0.1)",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      flexDirection: "row",
      paddingBottom: "2px",
    },

    tab: (isActive) => ({
      padding: isMobile ? "10px 16px" : "12px 24px",
      background: isActive
        ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
        : "transparent",
      color: isActive
        ? "white"
        : theme === "light"
          ? "#64748b"
          : "rgba(255, 255, 255, 0.7)",
      border: "none",
      borderRadius: "10px 10px 0 0",
      fontSize: isMobile ? "13px" : "14px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "6px" : "8px",
      whiteSpace: "nowrap",
      flexDirection: isRTL ? "row-reverse" : "row",
      outline: "none",
    }),

    requestCard: {
      padding: isMobile ? "16px" : "20px",
      border:
        theme === "light"
          ? "2px solid #e2e8f0"
          : "2px solid rgba(255, 255, 255, 0.15)",
      borderRadius: isMobile ? "10px" : "12px",
      marginBottom: isMobile ? "12px" : "16px",
      background:
        theme === "light" ? "#ffffff" : "rgba(255, 255, 255, 0.02)",
      transition: "all 0.3s ease",
      cursor: "pointer",
    },

    requestHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: isMobile ? "flex-start" : "center",
      flexWrap: "wrap",
      gap: isMobile ? "12px" : "16px",
      flexDirection: isRTL ? "row" : "row",
    },

    requestInfo: {
      flex: 1,
      minWidth: isMobile ? "100%" : "250px",
      textAlign: "left",
    },

    employeeName: {
      fontSize: isMobile ? "16px" : "18px",
      fontWeight: "600",
      color: theme === "light" ? "#0f172a" : "#ffffff",
      margin: "0 0 12px 0",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexDirection: "row",
    },

    requestDetail: {
      fontSize: isMobile ? "13px" : "14px",
      color:
        theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.7)",
      margin: "6px 0",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexDirection: "row",
      lineHeight: "1.5",
    },

    detailLabel: {
      fontWeight: "600",
      color:
        theme === "light"
          ? "#334155"
          : "rgba(255, 255, 255, 0.9)",
      minWidth: isMobile ? "70px" : "80px",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      flexDirection: "row",
    },

    button: {
      background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
      color: "white",
      border: "none",
      borderRadius: isMobile ? "8px" : "10px",
      padding: isMobile ? "10px 20px" : "12px 24px",
      fontSize: isMobile ? "13px" : "14px",
      fontWeight: "600",
      cursor: isLoading ? "not-allowed" : "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "6px" : "8px",
      whiteSpace: "nowrap",
      opacity: isLoading ? 0.7 : 1,
      outline: "none",
      flexDirection: isRTL ? "row-reverse" : "row",
      width: isMobile ? "100%" : "auto",
      justifyContent: "center",
    },

    emptyState: {
      textAlign: "center",
      padding: isMobile ? "40px 20px" : "60px 20px",
      color:
        theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
    },

    emptyStateTitle: {
      fontSize: isMobile ? "18px" : "20px",
      fontWeight: "600",
      marginBottom: "8px",
      marginTop: "16px",
      color:
        theme === "light"
          ? "#374151"
          : "rgba(255, 255, 255, 0.8)",
    },

    emptyStateDesc: {
      fontSize: isMobile ? "13px" : "14px",
      margin: 0,
    },

    modal: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      padding: isMobile ? "16px" : "20px",
      direction: isRTL ? "rtl" : "ltr",
    },

    modalContent: {
      background:
        theme === "light"
          ? "rgba(255, 255, 255, 0.98)"
          : "rgba(30, 41, 59, 0.98)",
      padding: isMobile ? "24px" : "32px",
      borderRadius: isMobile ? "16px" : "20px",
      width: "100%",
      maxWidth: isMobile ? "100%" : "500px",
      maxHeight: "85vh",
      overflowY: "auto",
      boxShadow:
        theme === "light"
          ? "0 20px 60px rgba(0, 0, 0, 0.2)"
          : "0 20px 60px rgba(0, 0, 0, 0.6)",
      color: theme === "light" ? "#0f172a" : "#ffffff",
      backdropFilter: "blur(20px)",
      border:
        theme === "light"
          ? "1px solid rgba(0, 0, 0, 0.1)"
          : "1px solid rgba(255, 255, 255, 0.1)",
    },

    modalTitle: {
      fontSize: isMobile ? "18px" : "20px",
      fontWeight: "700",
      marginBottom: isMobile ? "20px" : "24px",
      color: theme === "light" ? "#0f172a" : "#ffffff",
      textAlign: isRTL ? "right" : "left",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    formLabel: {
      display: "block",
      fontSize: isMobile ? "13px" : "14px",
      fontWeight: "600",
      color:
        theme === "light"
          ? "#334155"
          : "rgba(255, 255, 255, 0.9)",
      marginBottom: "8px",
      textAlign: isRTL ? "right" : "left",
    },

    textarea: {
      width: "100%",
      minHeight: isMobile ? "100px" : "120px",
      padding: isMobile ? "10px" : "12px",
      marginBottom: isMobile ? "20px" : "24px",
      border:
        theme === "light"
          ? "2px solid #e2e8f0"
          : "2px solid rgba(255, 255, 255, 0.2)",
      borderRadius: isMobile ? "10px" : "12px",
      background:
        theme === "light" ? "#f8fafc" : "rgba(255, 255, 255, 0.05)",
      color: theme === "light" ? "#0f172a" : "#ffffff",
      fontSize: isMobile ? "13px" : "14px",
      fontFamily: "inherit",
      resize: "vertical",
      outline: "none",
      transition: "border-color 0.3s ease",
      boxSizing: "border-box",
      textAlign: isRTL ? "right" : "left",
      direction: isRTL ? "rtl" : "ltr",
    },

    buttonGroup: {
      display: "flex",
      gap: isMobile ? "10px" : "12px",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    secondaryButton: {
      background:
        theme === "light"
          ? "rgba(0, 0, 0, 0.05)"
          : "rgba(255, 255, 255, 0.1)",
      color: theme === "light" ? "#374151" : "#ffffff",
      border: "none",
      borderRadius: isMobile ? "8px" : "10px",
      padding: isMobile ? "10px 20px" : "12px 24px",
      fontSize: isMobile ? "13px" : "14px",
      fontWeight: "600",
      cursor: isLoading ? "not-allowed" : "pointer",
      transition: "all 0.3s ease",
      opacity: isLoading ? 0.7 : 1,
      outline: "none",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexDirection: isRTL ? "row-reverse" : "row",
      flex: isMobile ? "1" : "0",
      justifyContent: "center",
    },

    actionButtons: {
      display: "flex",
      gap: "8px",
      flexDirection: "column",
      width: isMobile ? "100%" : "auto",
    },

    downloadButton: {
      background: "linear-gradient(135deg, #10b981, #059669)",
      color: "white",
      border: "none",
      borderRadius: "8px",
      padding: isMobile ? "10px 16px" : "8px 16px",
      fontSize: "13px",
      fontWeight: "600",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      transition: "all 0.3s ease",
      outline: "none",
      flexDirection: isRTL ? "row-reverse" : "row",
      justifyContent: "center",
      width: isMobile ? "100%" : "auto",
    },

    previewButton: {
      background:
        theme === "light"
          ? "rgba(0, 0, 0, 0.05)"
          : "rgba(255, 255, 255, 0.1)",
      color: theme === "light" ? "#374151" : "#ffffff",
      border: "none",
      borderRadius: "8px",
      padding: isMobile ? "10px 16px" : "8px 16px",
      fontSize: "13px",
      fontWeight: "600",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      transition: "all 0.3s ease",
      outline: "none",
      flexDirection: isRTL ? "row-reverse" : "row",
      justifyContent: "center",
      width: isMobile ? "100%" : "auto",
    },

    badge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: "4px 10px",
      borderRadius: "20px",
      fontSize: "11px",
      fontWeight: "600",
      background:
        theme === "light"
          ? "rgba(59, 130, 246, 0.1)"
          : "rgba(59, 130, 246, 0.2)",
      color: "#3b82f6",
      flexDirection: isRTL ? "row-reverse" : "row",
    },
  };
};

export default getResponsiveStyles;